import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import Navbar from '../Navbar/Navbar'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material/styles'
import Footer from '../Footer/Footer'

const Contact = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <div>
      <Navbar />
      <Box sx={{ textAlign: "center", mt: isMobile ? 2 : 3 }}>
        <Typography variant="h4" sx={{ fontWeight: "bold", mb: 1, fontSize: isMobile ? "1.5rem" : "2.125rem" }}>
          Contact Us
        </Typography>
        <Typography variant="body2" color="gray" sx={{ mb: 3, fontSize: isMobile ? "0.9rem" : "1rem" }}>
          We'd love to hear from you! Please fill out the form below and we'll get in touch.
        </Typography>
      </Box>
      <Box
        component="form"
        sx={{
          maxWidth: 500,
          width: "90%",
          mx: "auto",
          p: isMobile ? 2 : 3,
          display: "flex",
          flexDirection: "column",
          gap: 2,
          background: "#fafafa",
          borderRadius: 2,
          boxShadow: 2,
        }}
        noValidate
        autoComplete="off"
      >
        <TextField label="Name" variant="outlined" required size={isMobile ? "small" : "medium"} />
        <TextField label="Email" variant="outlined" type="email" required size={isMobile ? "small" : "medium"} />
        <TextField label="Subject" variant="outlined" size={isMobile ? "small" : "medium"} />
        <TextField
          label="Message"
          variant="outlined"
          multiline
          rows={isMobile ? 3 : 4}
          required
          size={isMobile ? "small" : "medium"}
        />
        <Button variant="contained" color="primary" sx={{ mt: 1, fontSize: isMobile ? "0.9rem" : "1rem" }}>
          Send Message
        </Button>
      </Box>
      <Box sx={{ maxWidth: 500, width: "90%", mx: "auto", mt: 4, p: 2 }}>
        <Typography variant="subtitle1" sx={{ fontWeight: "bold", fontSize: isMobile ? "1rem" : "1.1rem" }}>
          Contact Information
        </Typography>
        <Typography sx={{ fontSize: isMobile ? "0.95rem" : "1rem" }}>Email: <a href="mailto:sbobby065@gmail.com">sbobby065@gmail.com</a></Typography>
        <Typography sx={{ fontSize: isMobile ? "0.95rem" : "1rem" }}>Phone: <a href="tel:+919603198840">9603198840</a></Typography>
        <Typography sx={{ fontSize: isMobile ? "0.95rem" : "1rem" }}>Address: 4-8-40, Chinnadevara Street, Ichapuram, Srikaulam, AP 532127.</Typography>
      </Box>
      <Footer/>
    </div>
  )
}

export default Contact